import defaultAvatar from "./default-avatar.svg";
import cat from "./cat.svg";
import frog from "./frog.svg";
import owl from "./owl.svg";
import fox from "./fox.svg";
import panda from "./panda.svg";
import robot from "./robot.svg";
import bee from "./bee.svg";
import dino from "./dino.svg";

export const AVATAR_PRESETS = [
    { id: "preset-1", src: cat, label: "Gato" },
    { id: "preset-2", src: frog, label: "Rana" },
    { id: "preset-3", src: owl, label: "Búho" },
    { id: "preset-4", src: fox, label: "Zorro" },
    { id: "preset-5", src: panda, label: "Panda" },
    { id: "preset-6", src: robot, label: "Robot" },
    { id: "preset-7", src: bee, label: "Abeja" },
    { id: "preset-8", src: dino, label: "Dinosaurio" },
];

export const DEFAULT_AVATAR_ID = AVATAR_PRESETS[0].id;

const PRESET_BY_ID = new Map(
    AVATAR_PRESETS.map((preset) => [preset.id, preset]),
);

export const isAvatarPresetId = (value) => PRESET_BY_ID.has(value);

export const MAX_AVATAR_PHOTO_CHARS = 64 * 1024;

const PHOTO_DATA_URL =
    /^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/]+={0,2}$/;

export const isAvatarPhoto = (value) =>
    typeof value === "string" &&
    value.length <= MAX_AVATAR_PHOTO_CHARS &&
    PHOTO_DATA_URL.test(value);

export const resolveAvatarSrc = (avatar) => {
    if (isAvatarPhoto(avatar)) return avatar;
    return PRESET_BY_ID.get(avatar)?.src || defaultAvatar;
};
